import React, { FC } from 'react';
import { StatusTip, Icon, Bubble } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TipContext from '@/pages/home/components/TipContext';
import RatiosRegionBar from './RatiosRegionBar';
import BreakDownBar from './BreakDownBar';
import DevicePie from './DevicePie';
import { get } from 'lodash-es';

import { useIntl } from 'umi';
import './index.scss';

const { LoadingTip } = StatusTip;

interface SystemRatiosProps {
  loading: boolean;
  ratioRegion: any;
  genderBreakdown: any[];
  ageBreakdown: any[];
  mobileDevice: any;
}

const SystemRatios: FC<SystemRatiosProps> = (props) => {
  const {
    loading,
    ratioRegion,
    ageBreakdown = [],
    genderBreakdown = [],
    mobileDevice = {},
  } = props;
  const { formatMessage } = useIntl();
  const pieData = get(mobileDevice, 'download', []);
  return (
    <div className="dbi-benchmark-rowbox">
      <CardSlotV2
        className="dbi-benchmark-cardbox dbi-mobile-benchmark-system benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>
              {formatMessage({ id: 'dbi_benchmark_system_demographics' })}
            </div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={formatMessage({id: 'dbi_benchmark_system_demographics_info'})}
            />
          </>
        }
      >
        {loading ? (
          <LoadingTip className="dbi-benchmark-chart-loading" />
        ) : (
          <div>
            {pieData?.length > 0 ? (
              <DevicePie pieData={pieData} />
            ) : (
              <div className="retention-top-game-container-loading device-pie-no-data">
                {formatMessage({ id: 'dbi_detail_no_data_under' })}
              </div>
            )}

            <div className="dbi-benchmark-breakdown-container">
              <BreakDownBar
                className="gender-breakdown"
                color={['#5086F3', '#F17C86']}
                data={genderBreakdown.sort(
                  (a, b) => b.metric?.charCodeAt() - a.metric?.charCodeAt(),
                )}
                position={[0, -120]}
                title={formatMessage({ id: `dbi_top_gender_breakdown` })}
              />
              <BreakDownBar
                className="age-breakdown"
                color={['#5FC8F2', '#AD53D4', '#F19E55']}
                data={ageBreakdown}
                position={[0, -147]}
                title={formatMessage({ id: `dbi_top_age_breakdown` })}
              />
            </div>
          </div>
        )}
      </CardSlotV2>
      <CardSlotV2
        className="dbi-benchmark-cardbox dbi-mobile-benchmark-system benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>{formatMessage({ id: 'dbi_benchmark_ratios_by_region' })}</div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={formatMessage({id: 'dbi_benchmark_ratios_by_region_info'})}
            />
          </>
        }
      >
        {loading ? (
          <LoadingTip className="dbi-benchmark-chart-loading" />
        ) : (
          <RatiosRegionBar ratiosData={ratioRegion} />
        )}
      </CardSlotV2>
    </div>
  );
};

SystemRatios.displayName = 'RevenuePercentage';

export default SystemRatios;
